export default __webpack_public_path__ + "static/search-function-4d5263f2deeed2b83a6f3a716e5a53b9.mp4";